import { render, staticRenderFns } from "./IframePageRender.vue?vue&type=template&id=77a666c7&"
import script from "./IframePageRender.vue?vue&type=script&lang=js&"
export * from "./IframePageRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports